import React, { useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { FormAnswerImage } from 'api/form';
import { Button } from 'components/atoms/button';
import { useUsersQuery } from 'queries/members';
import { AttachmentsModal } from './attachments-modal';

export const StyledButton = styled(Button)`
  padding: 0 !important;
`;
export const AttachmentRenderer = ({
  filesList = [],
}: {
  filesList: FormAnswerImage[];
}) => {
  const [showModal, setShowModal] = useState(false);
  const { data: users = [] } = useUsersQuery();

  const renderText = useMemo(() => {
    if (filesList.length === 1) {
      return filesList[0].name;
    }
    if (filesList.length > 1) {
      return (
        <FormattedMessage
          id="view_n_attachments"
          values={{ count: filesList.length }}
        />
      );
    }

    return null;
  }, [filesList]);

  const updatedFilesList = useMemo(() => {
    return filesList.map((file) => {
      return {
        ...file,
        createdByUserName:
          users.find((user) => user.userId === file.createdBy)?.firstName ??
          'Anonymous',
        fileExt:
          file.name.substring(
            file.name.lastIndexOf('.') + 1,
            file.name.length,
          ) || file.name,
      };
    });
  }, [filesList, users]);

  return (
    <>
      <StyledButton type="link" onClick={() => setShowModal(true)}>
        {renderText}
      </StyledButton>
      {showModal && (
        <AttachmentsModal
          attachmentsList={updatedFilesList}
          visible={showModal}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};
